import ItemViewSFC from "./ItemView.vue";
export const ItemView = ItemViewSFC;
